import task from 'helpers/task'
import inject from 'helpers/inject'

import ApiService from 'services/api'

import getApiKeys from 'tasks/getApiKeys'

export default task(async function({ domains, service_type }) {
  const api = inject(ApiService)
  const key = await api.request({
    url: '/api/keys',
    method: 'POST',
    data: { domains, service_type }
  })
  getApiKeys.perform()
  return key
}, {
  defaultValue: null
})



// WEBPACK FOOTER //
// ./src/tasks/createApiKey.js